import { api } from '../api-client';

export const createCustomer = async ({ email, password, firstName, lastName, phoneNumber }) => {
	const requestBody = {
		email: email,
		password: password,
		firstName: firstName,
		lastName: lastName,
		phoneNumber: phoneNumber,
	};

	const response = await api('/customer/create', {
		method: 'POST',
		body: JSON.stringify(requestBody),
	});

	if (response.code != 200) {
		if (response.code == 422) {
			throw new Error('Email is already registered');
		} else {
			throw new Error('Unexpected error');
		}
	}
};
